export const UserDataSummaryTexts = {
  caption: 'Моя анкета',
};
